import React, { useContext } from "react";

import GameContext from "../Context";

import "./TallyCounts.scss";
import { Penalty } from "../Engine/EngineHook";

function GameTallyCounts() {
  const { engine } = useContext(GameContext);

  const tally = engine.getTally();

  return (
    <div className="game-tally-counts">
      {tally && (
        <>
          <label>Hits:</label>
          <div className="count">{tally.hitCount}</div>
          <div className="penalty">{tally.hitCount * Penalty.hit}</div>

          <label>Reflections:</label>
          <div className="count">{tally.reflectionCount}</div>
          <div className="penalty">{tally.reflectionCount * Penalty.reflection}</div>

          <label>Misses:</label>
          <div className="count">{tally.missCount}</div>
          <div className="penalty">{tally.missCount * Penalty.missed}</div>

          <label>Detours:</label>
          <div className="count">{tally.detourCount}</div>
          <div className="penalty">{tally.detourCount * Penalty.detour}</div>
        </>
      )}
    </div>
  );
}

export default GameTallyCounts;
